import get from 'lodash.get';

const getWebsiteURL = (rootState) => get(rootState, 'partner.properties.website', null);

export default getWebsiteURL;
